import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { KzIconsRegistryService } from '../icon/kz-icons-registry.service';
import { kzIconsArrowright } from '../icon/generated-icons/kzIcons-arrowright.icon';
import { kzIconsArrowleft } from '../icon/generated-icons/kzIcons-arrowleft.icon';

@Component({
  selector: 'kz-pagination',
  template: `
    <div class="kz-pagin--page">
      <ng-container *ngIf="withRouterLinks; then withLinks; else withButtons"></ng-container>
      <ng-template #withButtons>
        <button type="button" (click)="page = page - 1" [disabled]="page == 1"><kz-icons name="arrowleft"></kz-icons></button>
        <span>{{ page }} / {{ totalPages }} </span>
        <button type="button" (click)="page = page + 1" [disabled]="page == totalPages"><kz-icons name="arrowright"></kz-icons></button>
      </ng-template>
      <ng-template #withLinks>
        <a [routerLink]="previousLink" *ngIf="page > 1" queryParamsHandling="preserve"><kz-icons name="arrowleft"></kz-icons></a>
        <button type="button" disabled="disabled" *ngIf="page == 1"><kz-icons name="arrowleft"></kz-icons></button>
        <span>{{ page }} / {{ totalPages }}</span>
        <a [routerLink]="nextLink" *ngIf="page < totalPages" queryParamsHandling="preserve"><kz-icons name="arrowright"></kz-icons></a>
        <button type="button" disabled="disabled" *ngIf="page == totalPages"><kz-icons name="arrowright"></kz-icons></button>
      </ng-template>
    </div>
    <div class="kz-pagin--count">
      <button *ngFor="let availableItemsPerPageValue of availableItemsPerPage" (click)="itemsPerPage = availableItemsPerPageValue"
              type="button"
              [class.kz-pagin--count-active]="itemsPerPage == availableItemsPerPageValue">{{ availableItemsPerPageValue }}</button>
    </div>`,
  styleUrls: ['./kz-pagination.component.scss'],
  host: {
    '[class]': '"kz-pagin"',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class KzPaginationComponent {
  private _page: number = 1;

  get page(): number {
    return this._page;
  }

  @Input()
  set page(value: number) {
    this._page = value;
    this.pageChange.emit(value);
  }

  private _pageChange: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  get pageChange(): EventEmitter<number> {
    return this._pageChange;
  }

  private _totalPages: number = 1;

  get totalPages(): number {
    return this._totalPages;
  }

  @Input()
  set totalPages(value: number) {
    if (value < 1) {
      return;
    }

    this._totalPages = value;
  }

  private _availableItemsPerPage: Array<Number> = [10, 20, 30];

  get availableItemsPerPage(): Array<Number> {
    return this._availableItemsPerPage;
  }

  @Input()
  set availableItemsPerPage(value: Array<Number>) {
    this._availableItemsPerPage = value;
  }

  private _itemsPerPage: number = 20;

  get itemsPerPage(): number {
    return this._itemsPerPage;
  }

  @Input()
  set itemsPerPage(value: number) {
    if (value < 1) {
      return;
    }

    if (!this.availableItemsPerPage.includes(value)) {
      return;
    }

    this._itemsPerPage = value;
    this.itemsPerPageChange.emit(value);

  }

  private _itemsPerPageChange: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  get itemsPerPageChange(): EventEmitter<number> {
    return this._itemsPerPageChange;
  }

  private _withRouterLinks = false;

  get withRouterLinks(): boolean {
    return this._withRouterLinks;
  }

  @Input()
  set withRouterLinks(value: boolean) {
    this._withRouterLinks = value;
  }

  private _previousLink = [''];

  get previousLink(): Array<string> {
    return this._previousLink;
  }

  @Input()
  set previousLink(value: Array<string>) {
    this._previousLink = value;
  }

  private _nextLink = [''];

  get nextLink(): Array<string> {
    return this._nextLink;
  }

  @Input()
  set nextLink(value: Array<string>) {
    this._nextLink = value;
  }

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this._kzIconsRegistryService.registerIcons([kzIconsArrowright, kzIconsArrowleft]);
  }

  ngOnInit(): void {
    this._changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._changeDetectorRef.detectChanges();
  }
}
